"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs = __importStar(require("qs"));
const baseURL = "https://auth.tidal.com/v1/oauth2";
exports.default = (axios) => ({
    /**
     * Generate a DeviceCode and UserCode.
     * After that, redirect the User to the verificationUriComplete URI
     */
    getDeviceToken: async ({ client_id, scope = "r_usr+w_usr+w_sub" }) => {
        const { data } = await axios({
            baseURL,
            method: "post",
            url: "device_authorization",
            data: qs.stringify({ client_id, scope }),
            responseType: "json",
        });
        return data;
    },
    /**
     * Using the DeviceCode, poll this endpoint with the defined interval until
     * it stops returning the "authorization_pending" error.
     */
    getAccessToken: async ({ client_id, client_secret, device_code, grant_type = "urn:ietf:params:oauth:grant-type:device_code", scope = "r_usr+w_usr", }) => {
        const { data } = await axios({
            baseURL,
            method: "post",
            url: "token",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            auth: {
                username: client_id,
                password: client_secret,
            },
            data: qs.stringify({
                client_id,
                device_code,
                grant_type,
                scope,
            }),
            responseType: "json",
            validateStatus: (status) => [200, 400].includes(status),
        });
        return data;
    },
    /**
     * Get an access_token using a refresh_token
     */
    useRefreshToken: async ({ client_id, client_secret, refresh_token, grant_type = "refresh_token", scope = "r_usr+w_usr", }) => {
        const { data } = await axios({
            baseURL,
            method: "post",
            url: "token",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            auth: {
                username: client_id,
                password: client_secret,
            },
            data: qs.stringify({
                client_id,
                refresh_token,
                grant_type,
                scope,
            }),
            responseType: "json",
        });
        return data;
    },
});
